import { useCallback, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header, LoaderComponent } from 'components/common';
import Property from 'components/PropertyCard';

import Duplex from 'assets/images/duplex.png';
import Owner from 'assets/images/owner.png';
import axiosData from 'services/fetchInterceptor';

import { useAccount } from 'wagmi';
import { useActiveListings, useMarketplace, useSDK } from '@thirdweb-dev/react';
import { ethers } from 'ethers';

const Explore = () => {
  const sdk = useSDK();

  const [activeRoute, setActiveRoute] = useState<string>('trending');
  const [properties, setProperties] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  console.log('loading', loading);

  const { category } = useParams();
  const history = useNavigate();

  useEffect(() => {
    if (category) setActiveRoute(category);
  }, [category]);

  const marketplace = useMarketplace(
    process.env.REACT_APP_MARKETPLACE_ADDRESS // Your marketplace contract address here
  );

  // data is the active listings, isLoading is a loading flag while we load the listings.
  const { data: listings, isLoading: loadingListings } =
    useActiveListings(marketplace);

  useEffect(() => {
    setLoading(loadingListings);
  }, [loadingListings]);

  console.log('loadingListings', loadingListings);

  useEffect(() => {
    // Connect your marketplace smart contract here (replace this address)

    setLoading(true);
    axiosData
      .get('/property/minted')
      .then((response) => {
        setProperties(response);
      })
      .catch((err) => {
        console.log('err', err);
      })
      .then(() => {
        setLoading(false);
      });

    // console.log(listings);
  }, []);

  function routeComponent({ route, routeName }: any) {
    return (
      <div
        onClick={() => {
          setActiveRoute(route);
          history(`/explore/${route}`);
        }}
        className={`text-white cursor-pointer py-2 px-4 ${
          activeRoute === route ? 'rounded  bg-primary-2' : ''
        }`}
        aria-hidden="true"
      >
        {routeName}
      </div>
    );
  }

  const ActiveExplore = useCallback(
    ({ routeName, route }: any) => routeComponent({ routeName, route }),
    [activeRoute]
  );

  const routes = [
    {
      routeName: 'Trending',
      route: 'trending',
    },
    {
      routeName: 'Top',
      route: 'top',
    },
    {
      routeName: 'Featured',
      route: 'featured',
    },
    {
      routeName: 'For sale',
      route: 'for-sale',
    },
    {
      routeName: 'For lease',
      route: 'for-lease',
    },
    {
      routeName: 'Mortgage',
      route: 'mortgage',
    },
  ];

  return (
    <>
      <div className="bg-black">
        {loading || loadingListings ? <LoaderComponent /> : ''}
        <Header />
        <div className="container mx-auto px-4 md:px-8 xl:px-16 mt-16">
          <div className="text-center lg:px-32 md:px-16 sm:px-8">
            <h1 className="text-7xl text-white font-medium leading-[6rem]">
              Explore the list of assets we have for you
            </h1>
            <p className="text-white lg:px-32 md:px-16 sm:px-8 mt-8">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit ut
              aliquam, purus sit amet luctus venenatis, lectus magna fringilla
              urna.{' '}
            </p>
          </div>
          <div className="lg:px-16 flex justify-around mt-20 mx-8 overflow-x-scroll">
            {routes.map(({ route, routeName }) => (
              <ActiveExplore key={route} route={route} routeName={routeName} />
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-16 mt-16 pb-32">
            {listings?.map((ppt: any) => {
              const checkIfBigNumber = ethers.BigNumber.isBigNumber(
                ppt.startTimeInEpochSeconds
              );
              let listingDate: any;
              if (checkIfBigNumber) {
                listingDate = ethers.BigNumber.from(
                  ppt.startTimeInEpochSeconds
                ).toNumber();
                listingDate = new Date(listingDate * 1000);
              } else {
                // TODO Remove once you change contract and empty database
                const date = new Date();
                listingDate = date;
              }

              // console.log(ppt);
              // const slug = ppt.asset.attributes['trait_type'] === 'slug'?
              let slug;
              let address;
              let type;

              if (ppt.asset.attributes) {
                Array.from(ppt?.asset?.attributes, (at: any) => {
                  if (at.trait_type === 'Slug') {
                    slug = at.value;
                  }
                  if (at.trait_type === 'Type') {
                    type = at.value;
                  }
                  if (at.trait_type === 'Address') {
                    address = at.value;
                  }
                  return at;
                });
              }

              return (
                <Property
                  propertyImage={ppt.asset.image}
                  propertyName={ppt.asset.name}
                  ownerPicture={Owner}
                  propertyPrice={ppt?.buyoutCurrencyValuePerToken?.displayValue}
                  propertyMaxPrice={
                    ppt?.reservePriceCurrencyValuePerToken?.displayValue
                  }
                  propertyOwner={ppt.sellerAddress}
                  key={ppt.id}
                  propertyAdress={address}
                  propertyType={type}
                  propertyCreatedOn={listingDate.toDateString()}
                  propertyId={ppt.propertyId}
                  propertySlug={slug}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Explore;
